module.exports = __webpack_public_path__ + "static/media/ctm-bg1-min1.03870e6d.svg";